// extracted by mini-css-extract-plugin
module.exports = {"ttp-switch":"Switch_ttp-switch__2zJyB"};